<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolExternalInspectionResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit"
                                               v-api-permission="['%/sithMesStoolExternalInspection/assignInspector','edit']"
                                               :disabled="$store.state['sithMesStoolExternalInspection'].checkedItems.length < 1"
                                               custom-label="指派检验员"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="showInspectorsDialog()">
                                        指派检验员
                                    </em-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolExternalInspection'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openExternalInspectionResultModal">更新检验结果
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="指派检验员" width="25%" :visible.sync="showAssignInspectorModal">
            <el-form :model="assignInspectorForm" :rules="assignInspectorFormRules" ref="assignInspectorForm">
                <el-row>
                    <el-form-item label="请选择检验员" prop="inspector">
                        <el-select v-model="assignInspectorForm.inspector" filterable placeholder="请选择">
                            <el-option v-for="item in inspectorOptions" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="计划检验时间" prop="planInspectionTime">
                        <el-date-picker v-model="planInspectionTime" type="datetime"
                                        placeholder="选择日期时间"></el-date-picker>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showAssignInspectorModal = false">取 消</el-button>
                <el-button type="primary" @click="assignInspector()">确 定</el-button>
            </div>
        </el-dialog>

        <ReBModal header="更新检验结果"
                  @ok="updateInspectionResult"
                  ref="updateInspectionResultModal">
            <el-form :model="updateInspectionResultForm" :rules="updateInspectionResultFormRules"
                     ref="externalInspectionForm" label-width="100px">
                <el-form-item label="检验状态" prop="inspectionStatus">
                    <el-select v-model="updateInspectionResultForm.inspectionStatus" placeholder="请选择">
                        <el-option
                            v-for="item in inspectionStatusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="检验报告">
                    <multi-attachment class="w-100"
                                      :query-api="attachmentQueryApi"
                                      @loading="attachmentLoading"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds"></multi-attachment>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="updateInspectionResultForm.remark" type="textarea"></el-input>
                </el-form-item>

            </el-form>
        </ReBModal>
    </div>
</template>
<script>
// Author panyurou
// Date 2023-02-22 14:02:00

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emApiMixin from "@/mixin/em/common/api";
import moment from "moment";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

export default {
    name: "sithMesStoolExternalInspectionListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emApiMixin, PageMaterialDownloadBomDrawingMixin],
    components: {MiniButton, MultiAttachment, ReBModal},
    data() {
        return {
            showAssignInspectorModal: false,
            inspectorOptions: [],
            inspectionStatusOptions: [
                {value: '0', label: '未检验'},
                {value: '1', label: '检验合格'},
                {value: '2', label: '检验不合格'},
                {value: '3', label: '放弃检验'}
            ],
            assignInspectorForm: {
                inspector: [],
            },
            updateInspectionResultForm: {
                inspectionStatus: 0,
                remark: ''
            },
            attachmentIds: '',
            planInspectionTime: new Date(),
            assignInspectorFormRules: {
                inspector: [
                    {required: true, message: '请选择检验员', trigger: 'blur'}
                ]
            },
            updateInspectionResultFormRules: {
                inspectionStatus: [
                    {required: true, message: '请选择检验状态', trigger: 'blur'}
                ],
                remark: [
                    {required: true, message: '请输入备注', trigger: 'blur'}
                ]
            },
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        attachmentQueryApi() {
            return `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesStoolPo/getAttachmentList`;
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        }
    },
    methods: {
        assignInspector() {
            this.showAssignInspectorModal = false;
            console.log('$_emCustomVuexMixin_entity', this.$_emCustomVuexMixin_entity)
            let self = this;
            self.$refs["assignInspectorForm"].validate(valid => {
                if (valid) {
                    let ids = this.$store.state[this.modelName].checkedItems;
                    let url = this.$store.state.sithMesStoolExternalInspection.baseModuleUrl + "/sithMesStoolExternalInspection/assignInspector";
                    this.$_emApiMixin_post(url, {
                        ids: ids,
                        inspector: this.assignInspectorForm.inspector,
                        planInspectionTime: moment(this.planInspectionTime).format(
                            this.$t("em.datetime.format.viewMode")
                        )
                    }).then(() => {
                        this.$message.success("保存成功");
                        this.$refs.emListFilter.doQuery();
                    });
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return false;
                }
            })
        },

        showInspectorsDialog() {
            this.showAssignInspectorModal = true;
            this.inspectorOptions = [];
            const url = this.$store.state.emAclUser.baseModuleUrl + "/emAclRoleUser/getUserByRoleCode?code=qa_user_list";
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    data.forEach((item) => {
                        this.inspectorOptions.push({
                            value: item['loginName'],
                            label: item['name'] + '-' + item['loginName']
                        });
                    });
                });
        },
        openExternalInspectionResultModal() {
            let checkItem = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1)[0];
            this.attachmentIds = checkItem.inspectionReportIds;
            this.updateInspectionResultForm.inspectionStatus = checkItem.inspectionStatus.toString();
            this.updateInspectionResultForm.remark = checkItem.remark;
            this.$refs.updateInspectionResultModal.showModal();
        },
        updateInspectionResult() {
            let self = this;
            self.$refs["externalInspectionForm"].validate(valid => {
                if (valid) {
                    let id = this.$store.state[this.modelName].checkedItems[0];
                    let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolExternalInspection/updateInspectionResult";
                    this.$_emApiMixin_post(url, {
                        id: id,
                        inspectionStatus: Number.parseInt(this.updateInspectionResultForm.inspectionStatus),
                        remark: this.updateInspectionResultForm.remark,
                        inspectionReportIds: this.attachmentIds
                    }).then(() => {
                        this.$message.success("保存成功");
                        this.updateInspectionResultForm.remark = '';
                        this.$refs.emListFilter.doQuery();
                    });
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return false;
                }
            })
        },
        attachmentLoading(val) {
            this.$refs.updateInspectionResultModal.changeLoading(val);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
